"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorshipLinkProperty = exports.authorshipLinkPropertyDefinition = void 0;
exports.authorshipLinkPropertyDefinition = {
    view: { label: 'Authorship Person Link' },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'author',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'authorship-link',
};
const isAuthorshipLinkProperty = (prop) => {
    return prop.name === exports.authorshipLinkPropertyDefinition.name;
};
exports.isAuthorshipLinkProperty = isAuthorshipLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yc2hpcC1saW5rLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYXV0aG9yc2hpcC1saW5rLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLHdCQUF3QixFQUFFO0lBQ3pDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFO2dCQUNSLFFBQVE7Z0JBQ1IsU0FBUztnQkFDVCxRQUFRO2FBQ1Q7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxpQkFBaUI7Q0FDUSxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=